import { render, staticRenderFns } from "./learningSkills.vue?vue&type=template&id=a8a50b4c"
import script from "./learningSkills.vue?vue&type=script&lang=js"
export * from "./learningSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports